<template>
  <div class="sign-up-confirm-email">
    <SignBanner result="register" />
    <ModalComponentBody>
      <SignTitle>
        {{ messages?.thanksForRegister }}
      </SignTitle>
      <SignText>
        {{ text }}
      </SignText>
      <DefButtonPrimary v-if="messages?.goShopping" :href="messages?.goShopping?.href" tag="span">
        {{ messages?.goShopping?.text }}
      </DefButtonPrimary>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import SignBanner from '@components/Cabinet/Entry/SignBanner.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import SignTitle from '@components/Cabinet/Entry/SignTitle.vue';
import SignText from '@components/Cabinet/Entry/SignText.vue';
import { computed } from 'vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
const messages = computed(() => resultsStore?.messages?.entry);

const props = defineProps<{ text: string }>();
</script>

<style lang="scss" scoped>
.sign-up-confirm-email {
  :deep(.def-button-primary) {
    margin-top: 16px;
    width: 100%;
  }
  @include point-md {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.confirm-email-form {
}
</style>
